import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { TrainingsQuery as TrainingsQueryType, TrainingsQueryVariables } from "./__generated__/TrainingsQuery";

const TrainingsQuery = loader("./TrainingsQuery.gql");

type TrainingsQueryProviderType = (props: {
  children: (data: TrainingsQueryType) => ReactNode;
  variables: TrainingsQueryVariables;
}) => ReactElement;

export const TrainingsQueryProvider: TrainingsQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<TrainingsQueryType, TrainingsQueryVariables>(TrainingsQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
